import { createFileRoute, redirect } from "@tanstack/react-router";
import { optionalString } from "@/lib/search";

// Kept for reset links already in inboxes; the app's reset page takes the same token.
export const Route = createFileRoute("/careers/$slug/reset-password")({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: optionalString(search.token),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/reset-password", search: { token: search.token } });
  },
});
